const searchUrl = (query) => {
  query = encodeURIComponent(query)
  let url = window.location.href.split('?')[0]
  return `${url}?q=${query}`
}

export default searchUrl
